/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { CreateTicketCommentRequest } from '../models/create-ticket-comment-request';
import { GenericResponse } from '../models/generic-response';
import { GetTicketCommentResponse } from '../models/get-ticket-comment-response';
import { TicketCommentResponse } from '../models/ticket-comment-response';
import { UpdateTicketCommentRequest } from '../models/update-ticket-comment-request';

/**
 * ticket comments api
 */
@Injectable({ providedIn: 'root' })
export class TicketCommentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getTicketComments()` */
  static readonly GetTicketCommentsPath = '/api/v1/tickets/{id}/comments';

  /**
   * fetch ticket comments.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTicketComments()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTicketComments$Response(
    params: {
      /**
       * The ticket's id that needs to be fetched
       */
      id: number;

      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields:
       * - type
       * - name
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetTicketCommentResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      TicketCommentService.GetTicketCommentsPath,
      'get'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('search', params.search, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetTicketCommentResponse>;
        })
      );
  }

  /**
   * fetch ticket comments.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTicketComments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTicketComments(
    params: {
      /**
       * The ticket's id that needs to be fetched
       */
      id: number;

      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields:
       * - type
       * - name
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<GetTicketCommentResponse> {
    return this.getTicketComments$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<GetTicketCommentResponse>
        ): GetTicketCommentResponse => r.body
      )
    );
  }

  /** Path part for operation `createTicketComment()` */
  static readonly CreateTicketCommentPath = '/api/v1/tickets/{id}/comments';

  /**
   * Create new comment.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTicketComment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTicketComment$Response(
    params: {
      /**
       * The ticket's id that needs to add comment
       */
      id: number;
      body: CreateTicketCommentRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<TicketCommentResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      TicketCommentService.CreateTicketCommentPath,
      'post'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<TicketCommentResponse>;
        })
      );
  }

  /**
   * Create new comment.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createTicketComment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTicketComment(
    params: {
      /**
       * The ticket's id that needs to add comment
       */
      id: number;
      body: CreateTicketCommentRequest;
    },
    context?: HttpContext
  ): Observable<TicketCommentResponse> {
    return this.createTicketComment$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<TicketCommentResponse>): TicketCommentResponse =>
          r.body
      )
    );
  }

  /** Path part for operation `deleteTicketCommentById()` */
  static readonly DeleteTicketCommentByIdPath = '/api/v1/ticket-comments/{id}';

  /**
   * Delete ticket comment by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTicketCommentById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTicketCommentById$Response(
    params: {
      /**
       * The comment's id that needs to be delete
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      TicketCommentService.DeleteTicketCommentByIdPath,
      'delete'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * Delete ticket comment by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTicketCommentById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTicketCommentById(
    params: {
      /**
       * The comment's id that needs to be delete
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.deleteTicketCommentById$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `updateTicketCommentById()` */
  static readonly UpdateTicketCommentByIdPath = '/api/v1/ticket-comments/{id}';

  /**
   * Update Ticket Comment by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTicketCommentById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTicketCommentById$Response(
    params: {
      /**
       * The comment's id that needs to be update
       */
      id: number;
      body: UpdateTicketCommentRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<TicketCommentResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      TicketCommentService.UpdateTicketCommentByIdPath,
      'patch'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<TicketCommentResponse>;
        })
      );
  }

  /**
   * Update Ticket Comment by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTicketCommentById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTicketCommentById(
    params: {
      /**
       * The comment's id that needs to be update
       */
      id: number;
      body: UpdateTicketCommentRequest;
    },
    context?: HttpContext
  ): Observable<TicketCommentResponse> {
    return this.updateTicketCommentById$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<TicketCommentResponse>): TicketCommentResponse =>
          r.body
      )
    );
  }
}
